export default {"src":"/_next/static/media/digitalproduct-1.a0acbaac.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};